/**
 * Barwy do wykresów i pasków — jedno miejsce dla całej aplikacji.
 *
 * Klasy Tailwinda nie działają tam, gdzie barwę trzeba podać wartością:
 * szerokość odcinka paska idzie stylem, a `<svg>` wykresu bierze `fill`
 * i `stroke`. Heksy stoją więc w kodzie, tak samo jak w `statusTone.ts`,
 * i są przepisane z `tailwind.config.ts` — zmiana tam wymaga zmiany tutaj.
 *
 * Barwy stanów bierz z `STATUS_TONE_COLORS`; tutaj są tylko barwy serii
 * i wypełnień, które stanu nie niosą.
 */
export const CHART_PALETTE = {
  /** `accent-600` — seria bieżąca, wypełnienie domyślne. */
  accent: '#F2AD0D',
  /** `accent-700` — pierwszy odcień pochodny na wykresie kołowym. */
  accentDark: '#CC8F00',
  /** `accent-500` — trzeci odcień pochodny. */
  accentLight: '#F7CE6E',
  /** `neutral-300` — seria odniesienia, poprzednia edycja. */
  reference: '#C4C4D4',
  /** `neutral-400` — prognoza, seria pomocnicza. */
  muted: '#A6A6BE',
  /** `neutral-100` — tor paska pod wypełnieniem. */
  track: '#F0F0F5',
} as const;

/**
 * Kolejność odcieni dla serii bez własnej barwy — kategorie kosztów, których
 * katalog nie zdążył pomalować. Zaczyna się od akcentu, schodzi w neutralne,
 * żeby pierwsze pozycje legendy były najmocniejsze.
 */
export const CHART_SERIES_COLORS: string[] = [
  CHART_PALETTE.accentDark,
  CHART_PALETTE.accent,
  CHART_PALETTE.accentLight,
  CHART_PALETTE.muted,
  CHART_PALETTE.reference,
];
